import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './BusinessPrivacy.css';
import BusinessSidebar from "../../BusinessSidebar";
import Header from "../../BusinessHeaderAfterLogin";
import Footer from "../../BusinessFooterAfterLogin";

import loader from '../../../assests/loader.gif';
import API from '../../../Utils/Api';
import Image from 'react-bootstrap/Image';

const BusinessPrivacy = () => {

    const [loading,setLoading] = useState(false);
    const [img, setImg] = useState('');
    const [privacy, setPrivacy] = useState('<p></p>');

    useEffect(() => {
        document.title = `Business Privacy | Local Bells`;
        document.getElementById('bodywrap').className = 'busiprivacy';

        /* Start get privacy policy */
        let formData = new FormData();
        formData.append('type', 'privacy');
            API.post('get_page', formData)
                .then(response => {
                    setLoading(false);
                if(response.data.status === false){
                    
                }else{
                  setImg(response.data.data.image);
                  setPrivacy(response.data.data.content);
                }                  
            }).catch(error => {
                 
            });  
        /* End get privacy policy */

    }, []);

    // State to toggle sidebar visibility
    const [isSidebarVisible, setIsSidebarVisible] = useState(false);

    // Function to toggle sidebar visibility
    const toggleSidebar = () => {
        setIsSidebarVisible((prev) => !prev);
    };

    return (
        <>
            <section className="main-cont-box">
                <Container>
                    <Row>
                        <BusinessSidebar isVisible={isSidebarVisible} setIsVisible={setIsSidebarVisible}/>
                        <Col md={12} lg={9} xl={9} xxl={10} className='main-cont-box-right'>
                            <Header toggleSidebar={toggleSidebar} />
                            <div className='nei-cont'>
                                <div className='white-box static-cont'>
                                    <Row>
                                        <Col>
                                            <h3>Privacy Policy</h3>
                                        </Col>
                                    </Row>
                                    <Row className=''>
                                        {img && (
                                        <Col xs={12} className="mb-4">
                                                <Image
                                                  src={img}
                                                  className="img-fluid "
                                                  alt="wp"
                                                />
                                        </Col>
                                        )}
                                        <Col xs={12}>
                                            <div dangerouslySetInnerHTML={{__html: privacy}} />
                                        </Col>
                                   </Row>
                                </div>
                                <div className='footer-org footer'>
                                    <Footer />                                
                                </div>                                   
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            {loading && (
               <div className="loadingClass">
                <img src={loader} alt="loader"/>
              </div>
               )}  
        </>
    )
}

export default BusinessPrivacy;


